import './nelsons2/style';
import FormStructure from './nelsons2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js